a<template>
  <div id="admin" :class="{admin : acl.admin}">
    <div class="admin-left sidebar">
      <!-- CLIENTS -->
      <div class="sidebar-group">
        <div class="sidebar-group-name">Clients</div>
        <div class="sidebar-group-actions">
          <el-tooltip content="Add client"
              v-if="isSysAdmin"
              placement="right">
            <i class="bi bly-plus icon-btn" @click="createClientDialog = true"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="sidebar-item"
        :class="clientClassNames(id)"
        v-for="(client, id) in clients" :key="id">
        <div class="sidebar-item-name" @click="goToClient(client.id)">
         {{client.name | defaultValue('---')}}
        </div>
        <div class="sidebar-item-actions">
          <i class="bi bly-delete icon-btn"
            v-if="isSysAdmin"
            @click="deleteClientPrompt(id)"></i>
        </div>
      </div>
      <el-drawer
          custom-class="clients-push-nav"
          size="300px"
          title="Select client from the list"
          :visible.sync="showClientDrawer"
          :with-header="false">
          <div v-bar class="drawer-wrapper">
            <div class="drawer-client-list">
              <el-dropdown-item class=""
                :class="clientClassNames(id)"
                v-for="(client, id) in clients" :key="id">
                <span class="" @click="goToClient(client.id)">
                {{client.name | defaultValue('---')}}
                </span>
                  <i class="bi bly-delete icon-btn"
                    v-if="isAdmin"
                    @click="deleteClientPrompt(id)"></i>
              </el-dropdown-item>
              <el-dropdown-item icon="bi bly-plus"
                divided
                 @click.native="createClientDialog = true">
                Create client
              </el-dropdown-item>
            </div>
          </div>
        </el-drawer>
      <!-- ACCOUNTS
      <div class="sidebar-group">
        <div class="sidebar-group-name">Accounts</div>
        <div class="sidebar-group-actions">
        </div>
      </div>

      <div class="sidebar-item"
        v-for="(account, id) in accounts" :key="id">
        <div class="sidebar-item-name" @click="goToClient(account.id)">
         {{account.name | defaultValue('---')}}
        </div>
        <div class="sidebar-item-actions">
          <bly-button type="clear" @click.native="deleteAccountPrompt(id)">
            <i class="bi bly-delete"></i>
          </bly-button>
        </div>
      </div>
      -->

      <!-- FEATURES -->
      <div class="sidebar-group" v-if="isDevAdmin">
        <div class="sidebar-group-name">Features</div>
        <div class="sidebar-group-actions">
          <el-tooltip content="Add feature" placement="right">
             <bly-button type="clear" @click.native="createFeatureDialog = true">
              <i class="bi bly-plus"></i>
            </bly-button>
          </el-tooltip>
        </div>
      </div>

      <div v-if="isDevAdmin">
        <div class="sidebar-item"
          v-for="(item, id) in features" :key="id">
          <div class="sidebar-item-name">
            <span class="code">{{item.feature.code}}</span>
            {{item.feature.name}}
          </div>
          <div class="sidebar-item-actions">
            <bly-button type="clear" @click.native="deleteFeaturePrompt(id)">
              <i class="bi bly-delete"></i>
            </bly-button>
          </div>
        </div>
      </div>

      <!-- CLAIMS -->

      <div class="sidebar-group" v-if="isDevAdmin">
        <div class="sidebar-group-name">Claims</div>
        <div class="sidebar-group-actions">
          <el-tooltip content="Add claim" placement="right">
            <bly-button type="clear" @click.native="createClaimDialog = true">
              <i class="bi bly-plus"></i>
            </bly-button>
          </el-tooltip>
        </div>
      </div>

      <div v-if="isDevAdmin">
        <div class="sidebar-item"
          v-for="(claim, id) in claims" :key="id">
          <div class="sidebar-item-name">
            <span class="code">{{claim.code}}</span>
            {{claim.name}}
          </div>
          <div class="sidebar-item-actions">
            <bly-button type="clear" @click.native="deleteClaimPrompt(id)">
              <i class="bi bly-delete"></i>
            </bly-button>
          </div>
        </div>
      </div>

      <!-- USERS -->

      <div class="sidebar-group" v-if="isDevAdmin">
        <div class="sidebar-group-name">USERS</div>
        <div class="sidebar-group-actions">
          <el-tooltip content="Add user" placement="right">
             <bly-button type="clear" @click.native="createUserDialog = true">
              <i class="bi bly-plus"></i>
            </bly-button>
          </el-tooltip>
        </div>
      </div>

      <div v-if="isDevAdmin">
        <div class="sidebar-item"
          v-for="(user, id) in users" :key="id">
          <div class="sidebar-item-name">
            {{user.name}}
            <small>{{user.email}}</small>
          </div>
          <div class="sidebar-item-actions">
            <bly-button type="clear" @click.native="deleteUserPrompt(user.id)">
              <i class="bi bly-delete"></i>
            </bly-button>
          </div>
        </div>
      </div>
    </div>
    <div class="admin-content transition-wrapper">
      <transition name="slide" mode="out-in" appear>
        <router-view />
      </transition>
    </div>

    <!--
      ------------------------------
      DIALOG WINDOWS
      ------------------------------
     -->

    <!-- ADD CLIENT -->
    <el-dialog
      title="Create Client"
      :visible.sync="createClientDialog"
      :close-on-click-modal="false"
      :width="dialogWidth">
      <div class="dialog-form">
        <el-form ref="addClientForm" :model="clientForm" class="form-dark">
          <el-form-item required>
            <el-col :span="6">
              <el-form-item prop="code" label="Code" required>
                <el-input v-model="clientForm.code" placeholder="Code" maxlength="3"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1"> &nbsp; </el-col>
            <el-col :span="17">
              <el-form-item  prop="name" label="Name" required>
                <el-input v-model="clientForm.name" placeholder="Company name"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item required>
            <el-col :span="12">
              <el-form-item  prop="email" label="Email">
                <el-input v-model="clientForm.email" placeholder="Email address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1"> &nbsp; </el-col>
            <el-col :span="11">
              <el-form-item  prop="phoneno" label="Phone">
                <el-input v-model="clientForm.phoneno"  placeholder="Phone number"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item prop="description" label="Description">
            <el-input v-model="clientForm.description" placeholder="Description"></el-input>
          </el-form-item>
          <el-form-item prop="address" label="Address">
            <el-input v-model="clientForm.address" placeholder="Address"></el-input>
          </el-form-item>
          <el-form-item prop="website" label="Website URL">
            <el-input v-model="clientForm.website" placeholder="Website"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createClientDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addClient()">Save</el-button>
      </span>
    </el-dialog>

    <!-- ADD FEATURE -->
    <el-dialog
      title="Create Feature"
      :visible.sync="createFeatureDialog"
      :close-on-click-modal="false"
      :width="dialogWidth">
      <div class="dialog-form">
        <el-form :model="featureForm">
          <el-form-item required>
            <el-col :span="6">
              <el-form-item prop="code">
                <el-input v-model="featureForm.code" placeholder="Code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1"> &nbsp; </el-col>
            <el-col :span="17">
              <el-form-item  prop="name">
                <el-input v-model="featureForm.name" placeholder="Feature name"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item prop="description">
            <el-input v-model="featureForm.description" placeholder="Description"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createFeatureDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addFeature()">Save</el-button>
      </span>
    </el-dialog>

    <!-- ADD CLAIM -->
    <el-dialog
      title="Create Feature"
      :visible.sync="createClaimDialog"
      :close-on-click-modal="false"
      :width="dialogWidth">
      <div class="dialog-form">
        <el-form :model="claimForm">
          <el-form-item required>
            <el-col :span="6">
              <el-form-item prop="code" required="">
                <el-input v-model="claimForm.code" placeholder="Code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1"> &nbsp; </el-col>
            <el-col :span="17">
              <el-form-item  prop="name" required="">
                <el-input v-model="claimForm.name" placeholder="Claim name"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item prop="description">
            <el-input v-model="claimForm.description" placeholder="Description"></el-input>
          </el-form-item>
          <el-form-item prop="feature">
            <el-select v-model="claimForm.featureClaimsId" placeholder="Select feature">
              <el-option
                v-for="item in features"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createClaimDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addClaim()">Save</el-button>
      </span>
    </el-dialog>

    <!-- ADD USER -->
    <el-dialog
      title="Create user"
      :visible.sync="createUserDialog"
      :close-on-click-modal="false"
      :width="dialogWidth">
      <div class="dialog-form">
        <el-form :model="userForm">
          <el-form-item prop="name" required="">
            <el-input v-model="userForm.name" placeholder="Name"></el-input>
          </el-form-item>
          <el-form-item  prop="email" required="">
            <el-input v-model="userForm.email" placeholder="Email address"></el-input>
          </el-form-item>
          <el-form-item label="Approved">
            <el-switch v-model="userForm.isApproved"></el-switch>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createUserDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addUser()">Save</el-button>
      </span>
    </el-dialog>

    <GlobalUsersDialog :visible.sync="showGlobalUsersDialog" />


    <div class="config mv-config flex items-center">
      <i class="w-10 h-10 icon-btn flex items-center justify-center" @click="showGlobalUsersDialog = true" v-if="isSysAdmin">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="Multiple-Users-2--Streamline-Ultimate" height="16" width="16">
  
        <g>
          <path d="M8.846666666666666 7.913333333333332a0.1933333333333333 0.1933333333333333 0 0 1 -0.11333333333333334 -0.15333333333333332 0.17333333333333334 0.17333333333333334 0 0 1 0.10666666666666666 -0.15999999999999998 2.1399999999999997 2.1399999999999997 0 1 0 -1.68 0 0.17333333333333334 0.17333333333333334 0 0 1 0.10666666666666666 0.15999999999999998 0.1933333333333333 0.1933333333333333 0 0 1 -0.11333333333333334 0.15333333333333332 2.6666666666666665 2.6666666666666665 0 0 0 -1.7866666666666666 2.493333333333333v2a0.32666666666666666 0.32666666666666666 0 0 0 0.32666666666666666 0.32666666666666666h0.5933333333333333a0.16666666666666666 0.16666666666666666 0 0 1 0.15999999999999998 0.15333333333333332l0.22 2.813333333333333a0.32666666666666666 0.32666666666666666 0 0 0 0.32666666666666666 0.3h2a0.32666666666666666 0.32666666666666666 0 0 0 0.32666666666666666 -0.3l0.24 -2.84a0.16666666666666666 0.16666666666666666 0 0 1 0.15999999999999998 -0.15333333333333332h0.5933333333333333a0.32666666666666666 0.32666666666666666 0 0 0 0.32666666666666666 -0.32666666666666666v-2a2.6666666666666665 2.6666666666666665 0 0 0 -1.7933333333333332 -2.466666666666667Z" fill="currentColor" stroke-width="0.6667"></path>
          <path d="M3.0866666666666664 3.76a0.18 0.18 0 0 1 -0.11333333333333334 -0.15333333333333332 0.18666666666666668 0.18666666666666668 0 0 1 0.09999999999999999 -0.15999999999999998 1.8133333333333335 1.8133333333333335 0 1 0 -1.5333333333333332 0 0.18 0.18 0 0 1 0.09333333333333334 0.15999999999999998 0.18 0.18 0 0 1 -0.11333333333333334 0.15333333333333332A2.3 2.3 0 0 0 0 5.926666666666667v0.9866666666666666a0.3333333333333333 0.3333333333333333 0 0 0 0.09333333333333334 0.2333333333333333 0.3466666666666667 0.3466666666666667 0 0 0 0.2333333333333333 0.09333333333333334h0.5466666666666666a0.17333333333333334 0.17333333333333334 0 0 1 0.16666666666666666 0.14666666666666667L1.3333333333333333 9.913333333333332a0.3333333333333333 0.3333333333333333 0 0 0 0.32666666666666666 0.29333333333333333h1.3333333333333333a0.3333333333333333 0.3333333333333333 0 0 0 0.3333333333333333 -0.29333333333333333l0.27999999999999997 -2.5266666666666664a0.16666666666666666 0.16666666666666666 0 0 1 0.15999999999999998 -0.14666666666666667h0.5466666666666666a0.32666666666666666 0.32666666666666666 0 0 0 0.32666666666666666 -0.32666666666666666V5.926666666666667a2.3 2.3 0 0 0 -1.5533333333333332 -2.1666666666666665Z" fill="currentColor" stroke-width="0.6667"></path>
          <path d="M14.479999999999999 3.76a0.18 0.18 0 0 1 -0.11333333333333334 -0.15333333333333332 0.17333333333333334 0.17333333333333334 0 0 1 0.09999999999999999 -0.15999999999999998 1.8133333333333335 1.8133333333333335 0 1 0 -1.54 0 0.18666666666666668 0.18666666666666668 0 0 1 0.09999999999999999 0.15999999999999998 0.18 0.18 0 0 1 -0.11333333333333334 0.15333333333333332 2.3 2.3 0 0 0 -1.5199999999999998 2.1666666666666665v0.9866666666666666a0.31999999999999995 0.31999999999999995 0 0 0 0.32666666666666666 0.32666666666666666h0.5466666666666666a0.15999999999999998 0.15999999999999998 0 0 1 0.15999999999999998 0.14666666666666667l0.27999999999999997 2.5266666666666664a0.3333333333333333 0.3333333333333333 0 0 0 0.3333333333333333 0.29333333333333333h1.3333333333333333a0.3333333333333333 0.3333333333333333 0 0 0 0.32666666666666666 -0.29333333333333333l0.27999999999999997 -2.5266666666666664a0.17333333333333334 0.17333333333333334 0 0 1 0.16666666666666666 -0.14666666666666667h0.5466666666666666a0.32666666666666666 0.32666666666666666 0 0 0 0.32666666666666666 -0.32666666666666666V5.926666666666667a2.3 2.3 0 0 0 -1.54 -2.1666666666666665Z" fill="currentColor" stroke-width="0.6667"></path>
        </g>
      </svg>
      </i>
      <i class="bi bly-user icon-btn" @click="showClientDrawer = !showClientDrawer"></i>
    </div>
  </div>
</template>

<script setup>
import {
  ref, reactive, computed, onMounted, onBeforeUnmount, getCurrentInstance,
} from 'vue';
import { isMobileOnly } from 'mobile-device-detect';
import GlobalUsersDialog from '../components/Admin/GlobalUsersDialog.vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const router = proxy.$router;

// Data
const error = ref(null);
const isBtnLoading = ref(false);
const user = ref(null);
const state = reactive({});

const clientForm = reactive({
  code: '',
  name: '',
  description: null,
  email: null,
  phoneno: null,
  claimsCanAccess: [],
  claimsCanEdit: [],
  address: '',
  website: '',
});

const featureForm = reactive({
  code: '',
  name: '',
  description: null,
});

const userForm = reactive({
  email: '',
  name: '',
  claimsCanAccess: [],
  claimsCanEdit: [],
  isApproved: true,
});

const claimForm = reactive({
  code: '',
  name: '',
  description: null,
  featureClaimsId: '',
});

// Dialogs
const createClientDialog = ref(false);
const createFeatureDialog = ref(false);
const createClaimDialog = ref(false);
const createUserDialog = ref(false);
const showGlobalUsersDialog = ref(false);

// Other
const subscribers = ref({});
const showClientDrawer = ref(false);
const addClientForm = ref(null);

// Computed
const userId = computed(() => store.state.userAccount.userId);
const aclEx = computed(() => store.state.userAccount.userPermissions);
const acl = computed(() => store.state.userAccount.aclCurrent);
const isAdmin = computed(() => store.state.userAccount.isAdmin);
const isSysAdmin = computed(() => store.state.userAccount.isSysAdmin);
const isDevAdmin = computed(() => store.state.userAccount.isDevAdmin);
const clients = computed(() => store.state.admin.clients);
const features = computed(() => store.state.admin.features);
const claims = computed(() => store.state.admin.claims);
const users = computed(() => store.state.admin.users);
const clientId = computed(() => store.state.admin.clientId);
const accounts = computed(() => store.state.admin.accounts);

const dialogWidth = computed(() => (isMobileOnly ? '90%' : '420px'));


const clientClassNames = (id) => {
  const isActive = id === clientId.value;
  return isActive ? 'active' : '';
};

// Methods
const fetchClientList = () => store.dispatch('admin/fetchClientList');
const fetchClaimList = () => store.dispatch('admin/fetchClaimList');
const fetchFeatureList = () => store.dispatch('admin/fetchFeatureList');
const createClient = (payload) => store.dispatch('admin/createClient', payload);
const createClaim = (payload) => store.dispatch('admin/createClaim', payload);
const createFeature = (payload) => store.dispatch('admin/createFeature', payload);
const createUser = (payload) => store.dispatch('admin/createUser', payload);
const deleteUser = (id) => store.dispatch('admin/deleteUser', id);
const updateUser = (payload) => store.dispatch('admin/updateUser', payload);
const deleteClient = (payload) => store.dispatch('admin/deleteClient', payload);
const deleteClaim = (id) => store.dispatch('admin/deleteClaim', id);
const deleteFeature = (id) => store.dispatch('admin/deleteFeature', id);
const deleteAccount = (payload) => store.dispatch('admin/deleteAccount', payload);
const fetchAccountList = () => store.dispatch('admin/fetchAccountList');
const fetchUserList = () => store.dispatch('admin/fetchUserList');

const goToClient = (id) => {
  router.push({ name: 'admin-client', params: { id } }).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
  showClientDrawer.value = false;
};

const init = async () => {
  try {
    const clientsData = await fetchClientList();
    const firstClient = clientsData.items[0];

    if (!acl.value.admin && !!firstClient) goToClient(firstClient.id);

    await fetchClaimList();
    await fetchAccountList();
    await fetchFeatureList();
    if (isSysAdmin.value) {
      await fetchUserList();
    }
  } catch (err) {
    proxy.$message({
      showClose: true,
      message: 'Oops, something went wrong.',
      type: 'error',
    });
  }
};

const subscribe = () => {
  // Empty in original code
};

const unsubscribe = () => {
  Object.keys(subscribers.value).forEach((key) => {
    if (subscribers.value[key]) subscribers.value[key].unsubscribe();
  });
};

// Delete Prompts
const deleteAccountPrompt = async (id) => {
  const message = `Are you sure you want to delete <strong> ${accounts.value[id].name}</strong>?`;
  try {
    await proxy.$confirm(message, 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      dangerouslyUseHTMLString: true,
      type: 'warning',
      center: true,
    });

    const result = await deleteAccount({ id, version: accounts.value[id].version });
    if (result.error) {
      proxy.$message({
        showClose: true,
        message: 'Oops, can\'t get client list.',
        type: 'error',
      });
      return;
    }

    proxy.$message({
      showClose: true,
      message: 'Account deleted',
      type: 'info',
    });
  } catch (err) {
    console.log('error', err);
  }
};

const deleteClientPrompt = async (id) => {
  const message = `Are you sure you want to delete <strong> ${clients.value[id].name}</strong>?`;
  try {
    await proxy.$confirm(message, 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      dangerouslyUseHTMLString: true,
      type: 'warning',
      center: true,
    });

    const result = await deleteClient({ id, version: clients.value[id].version });
    if (result.error) {
      proxy.$message({
        showClose: true,
        message: 'Oops, can\'t get client list.',
        type: 'error',
      });
      return;
    }

    proxy.$message({
      showClose: true,
      message: 'Client deleted',
      type: 'info',
    });
  } catch (err) {
    console.log('error', err);
  }
};

const deleteFeaturePrompt = async (id) => {
  const message = `Are you sure you want to delete <strong> ${features.value[id].name}</strong>?`;
  try {
    await proxy.$confirm(message, 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      dangerouslyUseHTMLString: true,
      type: 'warning',
      center: true,
    });

    const result = await deleteFeature(id);
    if (result.error) {
      proxy.$message({
        showClose: true,
        message: 'Oops, can\'t delete feature.',
        type: 'error',
      });
      return;
    }

    proxy.$message({
      showClose: true,
      message: 'Feature deleted',
      type: 'info',
    });
  } catch (err) {
    console.log('error', err);
  }
};

const deleteClaimPrompt = async (id) => {
  const message = `Are you sure you want to delete <strong> ${claims.value[id].name}</strong>?`;
  try {
    await proxy.$confirm(message, 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      dangerouslyUseHTMLString: true,
      type: 'warning',
      center: true,
    });

    const result = await deleteClaim(id);
    if (result.error) {
      proxy.$message({
        showClose: true,
        message: 'Oops, can\'t delete claim.',
        type: 'error',
      });
      return;
    }

    proxy.$message({
      showClose: true,
      message: 'Claim deleted',
      type: 'info',
    });
  } catch (err) {
    console.log('error', err);
  }
};

const deleteUserPrompt = async (id) => {
  const message = `Are you sure you want to delete <strong> ${users.value[id].email}</strong>?`;
  try {
    await proxy.$confirm(message, 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      dangerouslyUseHTMLString: true,
      type: 'warning',
      center: true,
    });
    await deleteUser(id);
  } catch (err) {
    console.log('error', err);
  }
};

// Form Actions
const addClient = async () => {
  const isFormValid = await addClientForm.value.validate();
  if (!isFormValid) return;

  const { code } = clientForm;
  const newClient = {
    ...clientForm,
    id: code.toLowerCase(),
    code: code.toLowerCase(),
    clientLastUpdatedById: userId.value,
    claimsCanAccess: [`usr.${code}.${code}`, `usr.${code}`],
    claimsCanEdit: [`ca.${code}.${code}`, `aa.${code}.${code}`],
  };
  await createClient(newClient);
  createClientDialog.value = false;
};

const addClaim = async () => {
  const result = await createClaim(claimForm);
  if (result.error) {
    proxy.$message({
      showClose: true,
      message: 'Oops, can\'t get create claim.',
      type: 'error',
    });
    return;
  }

  proxy.$message({
    showClose: true,
    message: 'Claim added',
    type: 'info',
  });
  createClaimDialog.value = false;
};

const addFeature = async () => {
  const result = await createFeature(featureForm);
  if (result.error) {
    proxy.$message({
      showClose: true,
      message: 'Oops, can\'t get create feature.',
      type: 'error',
    });
    return;
  }
  proxy.$message({
    showClose: true,
    message: 'Feature added',
    type: 'info',
  });
  createFeatureDialog.value = false;
};

const addUser = async () => {
  const result = await createUser(userForm);
  if (result.error) {
    proxy.$message({
      showClose: true,
      message: 'Oops, can\'t get create user.',
      type: 'error',
    });
    return;
  }
  proxy.$message({
    showClose: true,
    message: 'User added',
    type: 'info',
  });
  createUserDialog.value = false;
};


// Lifecycle
onMounted(() => {
  init();
  subscribe();
});

onBeforeUnmount(() => {
  unsubscribe();
});
</script>

<style>


.el-loading-spinner svg {
  margin: 0 auto;
}

#admin {
  display: grid;
  grid-template-columns: 0px 1fr;
  overflow-x: hidden;
  grid-gap: 0px;
  margin: 20px;
  padding-top: 0;
}
#admin .title-card {
  grid-template-columns: 1fr;
}
#admin .sidebar {
  visibility: hidden;
}
#admin.admin {
  grid-template-columns: 260px 1fr;
  grid-gap: 20px;
}
#admin.admin .sidebar {
  visibility: visible;
}
#admin .content-header .data-header {
  grid-template-columns: 1fr auto;
}

.mobile #admin.admin {
  grid-template-columns: 0px 1fr;
  grid-gap: 0;
}
.mobile #admin.admin .sidebar {
  visibility: hidden;
}
.mobile .drawer-client-list .el-dropdown-menu__item {
  position: relative;
  line-height: 44px;
}
.mobile .drawer-client-list .el-dropdown-menu__item *.active {
  color: #ff9f31;
  font-weight: bold;
}
.mobile .drawer-client-list .el-dropdown-menu__item .icon-btn {
  position: absolute;
  right: 0;
}
</style>
